export default {
    baseStyle: {
        container: {
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '5px',
            display: 'block'
        },
        overlay: {
            position: 'absolute',
            inset: '0',
            pointerEvents: 'none',
            zIndex: '1',
            borderRadius: '5px'
        },
        image: {
            width: '100%',
            height: 'auto',
            display: 'block',
            borderRadius: '5px'
        },
        ctaText: {
            textUnderlineOffset: '4px',
            fontSize: '16px',
            fontWeight: '500',
            letterSpacing: '0.08px',
            zIndex: '2',
            transition: 'all 0.3s ease',
            _groupHover: {
                textDecoration: 'underline'
            }
        }
    },
    parts: ['container', 'overlay', 'image', 'ctaText']
}
